import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import ProjectValidationSchema from 'src/validation/ProjectValidationSchema';
import { ValidationMessages } from 'src/components/common/ValidationMessage';
import { deleteProject } from "src/store/project";
import { getClients } from "src/store/client";
import { getProjects } from "src/store/project";
import { getUsers } from "src/store/user";
import { getMcode } from "src/store/mcode";
import { getSingleProjects } from "src/store/project";
import { resetSingleProject, resetStateIdele } from 'src/store/project';
import { formatDate } from "src/utils/Helper";
import { CopyContext } from 'src/context/CopyContext';
import { format } from "date-fns";

const ProjectForm = (props) => {
  const {
    id = 0
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [validationMessages, setValidationMessages] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const user = useSelector((state) => state.user.data);
  const authCd = useSelector((state) => state.mcode.data.projectcategory);
  const clientName = useSelector((state) => state.client.data);
  const projectStatus = useSelector((state) => state.project.status);
  const projectSingleData = useSelector((state) => state.project.singleData);
  const { copyFlg } = useContext(CopyContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(ProjectValidationSchema),
    mode: 'onSubmit',
    defaultValues: {
      id: id,
    }
  });

  const onSubmit = (data) => {
    const formattedStartDate = format((data.start_date), "yyyy-MM-dd");
    const formattedEndDate = format((data.end_date), "yyyy-MM-dd");
    const formattedOrderDate = formatDate(data.order_date);
    const formattedBillingDate = formatDate(data.billing_date);

    const formatedData = {
      ...data,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      order_date: formattedOrderDate,
      billing_date: formattedBillingDate,
    }
    navigate("/projectConfirm", { state: { formData: formatedData } });
  };

  const clickBackBtn = () => {
    navigate("/projectList");
  };

  const clickDeleteBtn = async () => {
    const deleteConfirmed = window.confirm("Are you sure you want to delete?");
    if (!deleteConfirmed) {
      return; // Exit if the user cancels the confirmation
    }
    dispatch(deleteProject(id))
    .then((response) => {
      if(response.payload?.errors) {
        const messagesArray = Object.values(response.payload.errors).map((error) => error);
        setValidationMessages(messagesArray);
      }
      else if (deleteProject.fulfilled.match(response)) {
        alert(response.payload?.message);
        navigate("/projectList");
      }
      else if (deleteProject.rejected.match(response)) {
        setValidationMessages(response.error?.message);
      }
      else if (response?.error) {
        setValidationMessages(response.error.message);
      }
    })
    .catch((error) => {
      setValidationMessages([error.message]);
    });
  };
useEffect(() => {
  if (isDataLoaded) {
    if (location.state?.formData) {
      reset(location.state.formData);
    }
    else if (projectSingleData && Object.keys(projectSingleData).length !== 0) {
      const formattedData = {
        ...projectSingleData,
        start_date: projectSingleData.start_date ? format(new Date(projectSingleData.start_date), "yyyy-MM-dd") : "",
        end_date: projectSingleData.end_date ? format(new Date(projectSingleData.end_date), "yyyy-MM-dd") : "",
        order_date: projectSingleData.order_date ? format(new Date(projectSingleData.order_date), "yyyy-MM-dd") : "",
        billing_date: projectSingleData.billing_date ? format(new Date(projectSingleData.billing_date), "yyyy-MM-dd") : "",
        billing_plans_date: projectSingleData.billing_plans_date ? format(new Date(projectSingleData.billing_plans_date), "yyyy-MM-dd") : ""
      };
      reset(formattedData);
    }
  }
}, [isDataLoaded, location.state, projectSingleData, reset]);

 useEffect(() => {
  const fetchData = async () => {
    try {
      await Promise.all([
        dispatch(getClients({ name: 'name' })),
        dispatch(getProjects()),
        dispatch(getUsers()),
        dispatch(getMcode({ section_cd: 'projectcategory' })),
        dispatch(getSingleProjects(id))
      ]);
      setIsDataLoaded(true);
    } catch (error) {
      console.error('Error loading data:', error);
    }
  };

  fetchData();

  return () => {
    dispatch(resetSingleProject());
    setIsDataLoaded(false);
  };
}, [dispatch, id]);

  useEffect(() => {
    const messagesArray = Object.values(errors).map((error) => error.message);
    setValidationMessages(messagesArray);
  }, [errors]);
  
  useEffect(() => {
      if (validationMessages.length > 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth', 
        });
      }
    }, [validationMessages]);

  useEffect(() => {
    if (projectStatus === 'succeeded') {
      dispatch(resetStateIdele());
    }
  }, [projectStatus]);

  return (
    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
      <input type="hidden" {...register("id")} />
      {validationMessages && validationMessages.length > 0 && (
        <div style={{ background: "#ffe4e2" }}>
          <ValidationMessages
            messages={validationMessages}
            onClose={() => setValidationMessages([])}
          />
        </div>
      )}

      {/* Client */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Client *
        </label>
        <div className="col-sm-9">
          <select name="client_id" className="form-control" {...register("t_client_id")}>
            <option value="">-----</option>
            {clientName && clientName.map((client) => (
              <option
                key={client.id}
                value={(client.id)}
              >
                {client.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Project Name */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Name *
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            maxLength={128}
            {...register("name")}
          />
        </div>
      </div>

      {/* Project name (abbreviation) */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project name (abbreviation) *
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            maxLength={128}
            {...register("name_abbreviation")}
          />
        </div>
      </div>

      {/* Project Details */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Details
        </label>
        <div className="col-sm-9">
          <textarea
            type="textarea"
            rows="3"
            className="form-control"
            {...register("detail")}
          />
        </div>
      </div>

      {/* Project Category */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Category *
        </label>
        <div className="col-sm-9">
          <select name="category_cd" className="form-control"
            {...register("category_cd")}>
            <option value="">-----</option>
            {authCd && authCd.map((auth_cd) => (
              <option
                key={auth_cd.cd}
                value={auth_cd.cd}
              >{auth_cd.code_value1}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Order Date */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Order Date
        </label>
        <div className="col-sm-9 form-inline">
          <input
            type="date"
            className="form-control pj-datetimepicker"
            {...register("order_date")}
          />
        </div>
      </div>

      {/* Billing date (scheduled billing date) */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Billing date (scheduled billing date)</label>
        <div className="col-sm-9 form-inline">
          <input
            type="date"
            className="form-control pj-datetimepicker"
            {...register("billing_date")}
          />
          { !copyFlg ? (
            <>
            （&nbsp;
            <input
              type="date"
              className="form-control pj-datetimepicker"
              {...register("billing_plans_date")}
            />
            &nbsp;）
            </>
          ) : null }
        </div>
      </div>

      {/* Order amount (excluding tax) */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Order amount (excluding tax) *</label>
        <div className="col-sm-9">
          <input
            type="number"
            className="form-control"
            {...register("order_price")}
          />
        </div>
      </div>

      {/* Consumption tax rate */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Consumption tax rate *
        </label>
        <div className="col-sm-9">
          <input
            type="number"
            className="form-control"
            {...register("order_price_tax_rate")}
          />
        </div>
      </div>

      {/* Project duration */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project duration *
        </label>
        <div className="col-sm-9 form-inline">
          <input
            type="date"
            className="form-control pj-datetimepicker"
            {...register("start_date")}
          />
          &nbsp;～&nbsp;
          <input
            type="date"
            className="form-control pj-datetimepicker"
            {...register("end_date")}
          />
        </div>
      </div>

      {/* Project Leader */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Leader *
        </label>
        <div className="col-sm-9">
          <select name="manager_id" className="form-control" {...register("manager_id")}>
            <option value="">-----</option>
            {user && user.map((userItem) => (
              <option key={userItem.id} value={userItem.id}>
                {userItem.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Project Sub-Leader */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Sub-Leader *
        </label>
        <div className="col-sm-9">
          <select name="sub_manager_id" className="form-control" {...register("sub_manager_id")}>
            <option value="">-----</option>
            {user && user.map((userItem) => (
              <option key={userItem.id} value={userItem.id}>
                {userItem.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Buttons */}
      <div className="form-group text-center" style={{ marginTop: 60 }}>
        <button type="button" className="btn btn-default btn-lg" style={{ margin: "0 10px" }} onClick={clickBackBtn}>
          Back
        </button>
        <button type="submit" className="btn btn-success btn-lg jq-confirm_data" style={{ margin: "0 10px" }}>
          Confirm
        </button>
      </div>
      {id ? 
        <div className="form-group text-center">
          <button type="button" className="btn btn-default btn-lg" style={{ margin: "0 10px" }} onClick={clickDeleteBtn}>
            Delete
          </button>
        </div>
        : null
      }
    </form>
  );
};

export default ProjectForm;
